import { gql } from '@apollo/client'

const ERP_SHAPE_MAPPING_FIELDS = gql`
  fragment ErpShapeMappingFields on ErpShapeMapping {
    id
    createdAt
    updatedAt
    manufacturerId
    erp_schematic_id
    sofa_form_type
    default_parameters
    status
    erp_image_url
    erp_image_thumb_url
    notes
    last_seen_in_erp_at
    erp_item_count
    erp_sample_items
  }
`

export const GET_ERP_SHAPE_MAPPINGS = gql`
  ${ERP_SHAPE_MAPPING_FIELDS}
  query GET_ERP_SHAPE_MAPPINGS(
    $manufacturerId: Int!
    $status: ErpShapeMappingStatus
    $type: SofaFormType
    $search: String
    $take: Int
    $skip: Int
  ) {
    erpShapeMappingsCount(
      manufacturerId: $manufacturerId
      status: $status
      type: $type
      search: $search
    )
    erpShapeMappings(
      manufacturerId: $manufacturerId
      status: $status
      type: $type
      search: $search
      take: $take
      skip: $skip
    ) {
      ...ErpShapeMappingFields
    }
  }
`

// Every row for a manufacturer (a few hundred). The backend has no
// "missing image" filter, so that quick filter is applied client-side on this.
export const GET_ALL_ERP_SHAPE_MAPPINGS = gql`
  ${ERP_SHAPE_MAPPING_FIELDS}
  query GET_ALL_ERP_SHAPE_MAPPINGS($manufacturerId: Int!) {
    erpShapeMappingsForImport(manufacturerId: $manufacturerId) {
      ...ErpShapeMappingFields
    }
  }
`

export const GET_ERP_SHAPE_MAPPING = gql`
  ${ERP_SHAPE_MAPPING_FIELDS}
  query GET_ERP_SHAPE_MAPPING($id: Int!) {
    erpShapeMapping(id: $id) {
      ...ErpShapeMappingFields
    }
  }
`

export const UPSERT_ERP_SHAPE_MAPPING = gql`
  ${ERP_SHAPE_MAPPING_FIELDS}
  mutation UPSERT_ERP_SHAPE_MAPPING($input: ErpShapeMappingInput!) {
    upsertErpShapeMapping(input: $input) {
      ...ErpShapeMappingFields
    }
  }
`

export const DELETE_ERP_SHAPE_MAPPING = gql`
  mutation DELETE_ERP_SHAPE_MAPPING($id: Int!) {
    deleteErpShapeMapping(id: $id) {
      id
    }
  }
`

export const UPLOAD_ERP_SHAPE_MAPPING_IMAGE = gql`
  ${ERP_SHAPE_MAPPING_FIELDS}
  mutation UPLOAD_ERP_SHAPE_MAPPING_IMAGE($mappingId: Int!, $file: Upload!) {
    uploadErpShapeMappingImage(mappingId: $mappingId, file: $file) {
      ...ErpShapeMappingFields
    }
  }
`

export const GET_MAPPING_MANUFACTURERS = gql`
  query GET_MAPPING_MANUFACTURERS {
    findManyManufacturer {
      id
      manufacturer_profiles {
        id
        name
        language
      }
    }
  }
`

export const ERP_SHAPE_MAPPING_REFETCH = [
  'GET_ERP_SHAPE_MAPPINGS',
  'GET_ALL_ERP_SHAPE_MAPPINGS',
]
